import React, { Component } from "react";
import _ from 'lodash';
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  Button,
  WithStyles,
  createStyles,
} from "@material-ui/core";
import { FEEDBACK_AUTHOR_ACTIONS, FEEDBACK_INPUT_ACTIONS, FEEDBACK_VALIDATOR_ACTIONS, NEW_FEEDBACK_TIME_TO_SHOW, VALIDATION_PLACEHOLDER } from "../../helper/contentValidation";
import { getPropertyValue, scrollIntoView } from "../../../../utils";
import { MyPATDialog, dateService } from "../../../common";
import cx from "classnames"

const styles = (theme: Theme) => createStyles({
  feedbackAddSection: {
    top: '-8px',
    left: 'calc(100% + 20px)',
    border: '1px solid #1D7DEA',
    padding: '10px 10px !important',
    position: 'absolute',
    borderRadius: '4px',
    backgroundColor: '#fff',
    // height: '150px',
    // overflow: 'auto',
    zIndex: 10,
    minWidth: '290px',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.15)',
    '&::before': {
      content: "''",
      top: '15px',
      left: '-10px',
      width: '0',
      height: '0',
      position: 'absolute',
      borderTop: '5px solid transparent',
      borderRight: '10px solid #1D7DEA',
      borderBottom: '5px solid transparent',
    },
    '&::after': {
      content: "''",
      top: '15.7px',
      left: '-9px',
      width: '0',
      height: '0',
      position: 'absolute',
      borderTop: '4.5px solid transparent',
      borderRight: '10px solid #ffffff',
      borderBottom: '4.5px solid transparent',
    },
    '& .feedbackInnerBox': {
      maxHeight: '300px',
      overflowY: 'auto',
      display: 'block !important',
      paddingRight: '10px !important',
      position: 'relative',
      "&::-webkit-scrollbar": {
        width: '5px',
      },
      "&::-webkit-scrollbar-track": {
        background: '#dfdfdf',
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: '#8f99a5',
        borderRadius: '10px',
        border: '0px solid #ffffff',
      },
    },
    '& .titleRow': {
      display: 'flex !important',
      marginBottom: '8px',
      alignItems: 'center',
      '& h6': {
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '135%',
        color: '#666666',
        margin: '0',
      },
      '& .timeColumn': {
        color: '#999999',
        position: 'relative',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '135%',
        marginLeft: '5px',
        paddingLeft: '11px',
        '&::before': {
          content: "''",
          position: 'absolute',
          left: '0',
          top: '6px',
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: '#D9D9D9',
        }
      },
      '& .statusBtn': {
          backgroundColor: '#ffffff',
          border: '1px solid',
          fontSize: '12px',
          marginLeft: 'auto',
          fontWeight: 400,
          borderRadius: '50px',
          padding: '3px 10px',
          textTransform: 'capitalize',
        '&.resolved': {
          borderColor: '#30BE76',
          color: '#30BE76',
        },
        '&.open': {
          borderColor: '#FFBD27',
          color: '#FFBD27',
        },
        '&.challenged': {
          borderColor: '#1D7DEA',
          color: '#1D7DEA',
        },
        '&.rejected': {
          background: '#fff',
          color: '#EC1C24',
          border: '1px solid #EC1C24',
        },
        
      },
      '& img': {
        margin: 0,
        cursor: 'pointer',
      }
    },
    '& .titleHeading': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '135%',
      color: '#333333',
      margin: '0 0 16px',
      wordBreak: 'break-word',
    },
    '& textarea': {
      border: '1px solid #EFF7FF',
      borderRadius: '4px',
      backgroundColor: '#EFF7FF',
      fontSize: '12px',
      fontWeight: 400,
      color: '#333333',
      lineHeight: '133%',
      height: '107px',
      padding: '9px 7.5px',
      width: '100%',
      resize: 'none',
      fontFamily: 'Nunito',
      margin: '0',
      '&::-ms-input-placeholder': {
        color: '#999999',
        fontStyle: 'italic',
      },
      '&::placeholder': {
        color: '#999999',
        fontStyle: 'italic',
      },
      '&:focus': {
        outline: 'none',
      },
      '&.error': {
        borderColor: '#EC1C24',
        backgroundColor: '#ffffff',
        '&::-ms-input-placeholder': {
          color: '#EC1C24',
          fontStyle: 'italic',
        },
        '&::placeholder': {
          color: '#EC1C24',
          fontStyle: 'italic',
        }
      },
    },
    '& .buttonGroup':{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '10px 0 0',
      '&.align-end': {
        justifyContent: 'flex-end',
      },
      '& .disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& .btnText': {
        fontSize: '14px',
        fontWeight: 400,
        color: '#999999',
        lineHeight: '135%',
        padding: '5px 15px',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: 'pointer',
        fontFamily: 'Nunito',
      },
      '& .btnFill': {
        fontSize: '14px',
        fontWeight: 400,
        color: '#ffffff',
        lineHeight: '135%',
        padding: '5px 15px',
        backgroundColor: '#1D7DEA',
        minWidth: '67px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontFamily: 'Nunito',
      },
      '& .challenge': {
        color: '#1D7DEA'
      },
      '& .placeFirst': {
        float: 'left',
      },
      '&.justify-content-end': {
        justifyContent: 'flex-end',
      }
    },
  },
  moreActionContainer: {
    position: 'relative',
    display: "flex",
    marginLeft: 5,
    '&.rightAlign': {
      position: "absolute",
      right: 10,
    },
    '&>img:hover': {
      background: "#F4F4F4",
    },
    '& .moreActionPanel': {
      position: 'absolute',
      width:80,
      right:32,
      top:0,
      display: "flex",
      flexDirection: "column",
      gap:'5px',
      background: "#fff",
      boxShadow: "3px 1px 6px 0px #00000026",
      padding: "8px 10px",
      border: "solid .5px #e6e6e6",
      '&::before': {
        content: "''",
        borderTop: "7px solid #e6e6e6",
        borderLeft: "7px solid transparent",
        borderRight: "7px solid transparent",
        position: "absolute",
        top:10,
        transform: "rotate(270deg)",
        right:-10,    
      },
      '&::after': {
        content: "''",
        borderTop: "7px solid #fff",
        borderLeft: "7px solid transparent",
        borderRight: "7px solid transparent",
        position: "absolute",
        top:10,
        transform: "rotate(270deg)",
        right:-9,    
      },
      '& span': {
        fontSize:14,
        fontWeight:400,
        textAlign: "left",
        color: '#666',
        cursor: 'pointer', 
        '&:hover': {
          color: 'rgb(29 125 234)',
        } 
      }
    }
  },
  deletionDialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '40px',
    alignItems: 'center',
    fontSize:14,
    fontWeight:500,
    textAlign: "center",
    color: '#666',
    '& .deletionActions': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '24px',
      fontSize: 16,
      '& span': {
        cursor: 'pointer'
      }
    }
  },
  displayNone: {
    display: 'none',
  }
});

interface AddFeedbackPopupProps extends WithStyles<typeof styles> {
  feedbackData: any;
  handleCancel: Function;
  handleAdd: Function;
  isAuthor?: boolean;
  allowFeedbacks: boolean;
  feedbackActionId?: string
}

interface AddFeedbackPopupStates {
  textareaValue: string,
  showError: boolean,
  popUpRef: any,
  actionType: string;
  isMoreActionPlanelOpen: boolean;
  isFeedbackEdit: boolean;
  isFeedbackDeletionDialogOpen: boolean;
}
class AddFeedbackPopup extends Component<
  AddFeedbackPopupProps,
  AddFeedbackPopupStates
> {
  constructor(props: AddFeedbackPopupProps) {
    super(props);
    this.state = {
      textareaValue: '',
      showError: false,
      // @ts-ignore
      popUpRef: React.createRef(),
      actionType: '',
      isMoreActionPlanelOpen: false,
      isFeedbackEdit: false,
      isFeedbackDeletionDialogOpen: false,
    };
  }
  outSideClick = () => {
    const { handleCancel } = this.props;
    handleCancel && handleCancel();
  };

  handleOutsideClick = (event:any) => {
    if(this.state.isFeedbackEdit) return;
    if (this.state.popUpRef.current && !this.state.popUpRef.current.contains(event.target)) {
      this.outSideClick();
    } 
  };

  componentDidMount() {
    scrollIntoView('sectionFeedbackContainer');
    document.addEventListener('click', this.handleOutsideClick);
    let { feedbackActionId } = this.props;
    feedbackActionId = String(feedbackActionId);
    feedbackActionId && scrollIntoView(`comment-feedback-${feedbackActionId}`);
  }
  componentWillUnmount(): void {
    document.removeEventListener('click', this.handleOutsideClick);
  }

  handleCancelClick = (e: any) => {
    const { handleCancel, isAuthor, handleAdd } = this.props;
    if (isAuthor) {
      if (!this.state.textareaValue) {
        this.setState({ showError: true, actionType: FEEDBACK_INPUT_ACTIONS.CHALLENGE });
        return;
      }
      if(this.state.isFeedbackEdit) {
        this.setState({ isFeedbackEdit: false });
        handleAdd && handleAdd(this.state.textareaValue, FEEDBACK_AUTHOR_ACTIONS.CHALLENGED, true);
        return;
      }
      this.setState({ actionType: FEEDBACK_INPUT_ACTIONS.CHALLENGE });
      handleAdd && handleAdd(this.state.textareaValue, FEEDBACK_AUTHOR_ACTIONS.CHALLENGED);
      return;
    }
    handleCancel && handleCancel();
  }

  handleAddClick = (e: any) => {
    const { handleAdd, isAuthor } = this.props;
    if (isAuthor) {
      if (!this.state.textareaValue) {
        this.setState({ showError: true, actionType: FEEDBACK_INPUT_ACTIONS.RESOLVE });
      } else {
        if(this.state.isFeedbackEdit) {
          this.setState({ isFeedbackEdit: false });
          handleAdd && handleAdd(this.state.textareaValue, FEEDBACK_AUTHOR_ACTIONS.RESOLVED, true);
          return;
        }
        handleAdd && handleAdd(this.state.textareaValue, FEEDBACK_AUTHOR_ACTIONS.RESOLVED);
      }
      return;
    }
    if (!this.state.textareaValue) {
      this.setState({ showError: true });
      return;
    }
    if(this.state.isFeedbackEdit) {
      this.setState({ isFeedbackEdit: false });
      handleAdd && handleAdd(this.state.textareaValue, {}, true);
      return;
    }
    handleAdd && handleAdd(this.state.textareaValue);
  }

  handleChange = (event: any) => {
    event.stopPropagation();
    this.setState({ textareaValue: event.target.value, showError: false, });
  };

  getInputErrorPlaceholder = () => {
    const { actionType } = this.state;
    return actionType === FEEDBACK_INPUT_ACTIONS.CHALLENGE ? VALIDATION_PLACEHOLDER.CHALLENGE : VALIDATION_PLACEHOLDER.RESOLVE;
  }

  getInputPlaceholder = () => {
    const { isAuthor } = this.props;
    const { showError } = this.state
    let placeholder = VALIDATION_PLACEHOLDER.VALIDATOR;
    if (isAuthor) {
      placeholder = showError ? this.getInputErrorPlaceholder() : VALIDATION_PLACEHOLDER.AUTHOR;
    }
    return placeholder;
  }

  handleEditComment = (event: any, action: any) => {
    this.setState({isFeedbackEdit: true, isMoreActionPlanelOpen: false }, () => this.setState({textareaValue: action.comment}));
  }

  handleDeleteFeedbackClick = () => {
    this.setState({ isFeedbackDeletionDialogOpen: true });
    document.removeEventListener('click', this.handleOutsideClick);
  }

  onFeedbackDeletionConfirm = () => {
    const { handleAdd } = this.props;
    handleAdd && handleAdd('', {}, false, true);
  }

  handleDeletionDialogClose = () => {
    this.setState({ isFeedbackDeletionDialogOpen: false });
    document.addEventListener('click', this.handleOutsideClick);
  }

  closePopOverDialog = () => {
    const { handleCancel } = this.props;
    handleCancel && handleCancel();
  }

  render() {
    const { classes, feedbackData, isAuthor, allowFeedbacks = false } = this.props;
    const { isMoreActionPlanelOpen, isFeedbackEdit, isFeedbackDeletionDialogOpen } = this.state;
    const { actions = [], disableEditing = false } = feedbackData || {};
    const userData = JSON.parse(localStorage.getItem('patmy') || '');
    const userId = _.get(userData, 'authenticatedUser._id', '');
    let status = getPropertyValue(actions[actions.length - 1], 'validatorAction') || getPropertyValue(actions[actions.length - 1], 'authorAction');
    status = status === FEEDBACK_VALIDATOR_ACTIONS.REJECTED ? FEEDBACK_VALIDATOR_ACTIONS.OPEN : status;

    return (
      <div id="sectionFeedbackContainer" className={classes.feedbackAddSection} onClick={(e)=>{e.stopPropagation();}}>
        <div tabIndex={0} className="feedbackInnerBox" ref={this.state.popUpRef}>
          {
            (!actions.length || (isFeedbackEdit && actions.length === 1))
            ?
            <div className="titleRow">
              <h6>Feedback</h6>
            </div>
            :
            actions.map((action: any, index: number) => (
              <>
              {
                action.comment && (
              <div className={cx({[classes.displayNone]: (index === actions.length -1) && isFeedbackEdit})}>
                <div className="titleRow">
                  <h6>{action.authorAction ? 'Author Replied' : 'Feedback'}</h6>
                  <span className="timeColumn">{action.date !== NEW_FEEDBACK_TIME_TO_SHOW ? dateService.getTimeStamp(action.date) : action.date}</span>
                        {
                          !index && status && <button className={`statusBtn ${status}`}>{status}</button>
                        }
                        {(index === actions.length - 1) && userId === (action.userId || (action.user || {}).id) && allowFeedbacks && (!isAuthor || feedbackData.isEditable) &&
                          <div className={cx(classes.moreActionContainer, {'rightAlign': actions.length > 1})}>
                            <img src="/assets/svg/more-action.svg" alt="more action" onClick={() => this.setState({isMoreActionPlanelOpen: !isMoreActionPlanelOpen})}/>
                            {isMoreActionPlanelOpen &&
                              <div className="moreActionPanel">
                                <span onClick={(e) => this.handleEditComment(e, action)}>Edit</span>
                                {!isAuthor && <span onClick={this.handleDeleteFeedbackClick}>Delete</span>}
                              </div>
                            }
                          </div>
                        }
                </div>
                <h5 id={`comment-feedback-${index}`} className="titleHeading">{action.comment}</h5>
              </div>
              )}
              </>
            ))
          }
          {
            (!disableEditing && allowFeedbacks && ((!actions.length || (actions[actions.length-1].user && actions[actions.length-1].user.id !== userId)) || isFeedbackEdit)) &&
            <>
              <textarea 
                className={cx({ 'error': this.state.showError })}
                placeholder={this.getInputPlaceholder()}
                value={this.state.textareaValue}
                onChange={this.handleChange}
                autoFocus
              />
              <div className={cx("buttonGroup", {'align-end': !isAuthor}, {'justify-content-end': isAuthor && !isFeedbackEdit})}>
                { (isAuthor && isFeedbackEdit) && <button className={cx(['btnText', 'placeFirst', 'challenge'])} onClick={this.closePopOverDialog}>Cancel</button> }
                <span>
                  <button className={'btnText ' + cx('challenge', isAuthor)} onClick={(e) => this.handleCancelClick(e)}>{isAuthor ? 'Challenge' : 'Cancel'}</button>
                  <button className={'btnFill ' + cx({ 'disabled': !isAuthor && !this.state.textareaValue })} onClick={(e) => this.handleAddClick(e)}>{isAuthor ? 'Resolve' : (isFeedbackEdit ? 'Save' : 'Add')}</button>
                </span>
              </div>
            </>
          }
          <MyPATDialog
            dialogOpen={isFeedbackDeletionDialogOpen}
            otherDialogProps={{
              fullWidth: true,
              maxWidth: 'sm',
            }}
            customButtonVariant="withoutBorderCloseIcon"
            onDialogClose={this.handleDeletionDialogClose}
            dialogHeading={'Confirmation'}
          >
            <div className={classes.deletionDialogContent}>
              <div>Are you sure you want to delete this {actions.length > 1 ? 'reply' : 'feedback'}?</div>
              <div className="deletionActions">
                <span onClick={this.handleDeletionDialogClose} >Cancel</span>
                <Button color="primary" variant="contained" onClick={this.onFeedbackDeletionConfirm}>Yes, Proceed</Button>
              </div>
            </div>
          </MyPATDialog>
        </div>
      </div>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(AddFeedbackPopup);
